var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-share';
                    var viewUrl = 'sprite.svg#view-icon-share';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-share#icon-share';
                            viewUrl = 'sprite.svg?icon-share#view-icon-share';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 14.5 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };